// Comma delimited string constant of all accepted attachment file types (contains mixture of mime types and extensions)
export const ACCEPTED_FILE_TYPES = [
  'audio/mp3',
  '.avi',
  '.csv',
  '.doc',
  '.docx',
  '.flv',
  'image/*',
  '.mov',
  '.mp4',
  '.pdf',
  '.xls',
  '.xlsx',
  '.wav',
  '.wmv'
].join(',');